module.exports = __webpack_public_path__ + "img/bottom.3ada3106.png";